export default __webpack_public_path__ + "static/media/flexbox-2.bc21ca94.webp";